import React from 'react'

export default function HumanGoals({data}) {
  return (
    <>
      <section className="about-goals-area human-goals-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-9">
              <div className="about-goals-head">
                <h3 className="heading center-heading">{data?.head || "Why Dox and Box for HR?"}</h3>
              </div>
            </div>

            {data?.boxes?.map((item, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="about-trust-box">
                  <img src={item?.img} alt="Goal Box" />
                  <span>{item?.title}</span>
                  <p>{item?.desc}</p>
                </div>
              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  )
}
